import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
//import {getMGetInvolvedById} from "../reducers/index";
import * as cardActions from './cardActions';


//Action Creators
export const loadMGetInvolvedStart = (id) => {
  return {
    type: actionTypes.MGETINVOLVED_LOAD_START,
    id
  };
};
export const loadMGetInvolvedFail = (id, error) => {
  console.error(error);
  return {
    type: actionTypes.MGETINVOLVED_LOAD_FAIL,
    id,
    error
  };
};
export const loadMGetInvolvedSuccess = (data) => {
  return {
    type: actionTypes.MGETINVOLVED_LOAD_SUCCESS,
    data
  };
};

export const initMGetInvolved = () => dispatch => {
  dispatch(loadMGetInvolvedStart());

  apiActions
    .loadSingleType(apiValues.nref.mGetInvolved.endpoint)
    .then((result) => {
      const parentDocId = result.documentId || result.id;
      const mGetInvolved = apiActions.itemSelectCamelCaseKeys(result, apiValues.nref.mGetInvolved.fieldsUsed);

      const finishCards = (cardRows) => {
        const cards = apiActions.arraySelectCamelCaseKeys(cardRows || [], apiValues.nref.card.fieldsUsed);
        cards.forEach((card) => {
          dispatch(cardActions.loadCardSuccess(card));
        });
        mGetInvolved.cards = cards.map((card) => card.id);
        dispatch(loadMGetInvolvedSuccess(mGetInvolved));
      };

      if ((mGetInvolved.cards || []).length > 0) {
        return finishCards(mGetInvolved.cards);
      }
      return apiActions
        .loadInverseRelationList(apiValues.nref.card.endpoint, 'mGetInvolved', parentDocId)
        .then((list) => finishCards(list || []));
    })
    .catch((err) => dispatch(loadMGetInvolvedFail(err)));
};


